module.exports = __webpack_public_path__ + "static/media/tray17.b51cf99a.png";